import { Component } from '@angular/core';

@Component({
  selector: 'footer',
  templateUrl: 'footer.template.html'
})
export class FooterComponent {
  copyYear = (new Date()).getFullYear();
 }
